import type { Insurer } from 'BrokerTsLib/src/enums'
import { logos } from 'brokertslib/src/utils'

export const getLogo = (insurerId: Insurer): string => {
  return logos.get(insurerId) as string
}